import FaceBookIcon from "@/components/icons/FaceBookIcon";
import InstagramIcon from "@/components/icons/InstagramIcon";
import LinkedinIcon from "@/components/icons/LinkedinIcon";
import TwitterIcon from "@/components/icons/TwitterIcon";
import YoutubeIcon from "@/components/icons/YoutubeIcon";
import Image from "@/components/global/Image";
import Link from "next/link";
import CompareProductFooter from "@/components/layout/CompareProductFooter";

const FooterApps = ({ t }) => {
  return (
    <div className="flex flex-col flex-wrap items-center justify-center w-11/12 gap-4 mx-auto mb-5 sm:mb-10 sm:gap-6 sm:flex-row">
      <p className="font-bold uppercase max-sm:text-sm">
        {t("download our app")}
      </p>
      <div className="flex items-center gap-x-6">
        <Link
          href={
            "https://apps.apple.com/sa/app/abdulwahed-shopping-app/id1548762547"
          }
        >
          <Image
            loading="lazy"
            src="/imgs/appstore.webp"
            className="object-contain w-24 h-auto cursor-pointer"
            alt="Apple Store Img !"
          />
        </Link>
        <Link
          href={
            "https://play.google.com/store/apps/details?id=com.abdulwahed&hl=en_US&gl=US"
          }
        >
          <Image
            loading="lazy"
            src="/imgs/palystore.webp"
            className="object-contain w-24 h-auto"
            alt="Google Play Img !"
          />
        </Link>
      </div>
      <div className="flex flex-col flex-wrap items-center justify-center gap-2 md:flex-row">
        <p className="font-bold max-sm:text-sm">{t("Follow Us On")} : </p>
        <div className="flex items-center gap-4 sm:gap-2 max-sm:*:size-8 *:size-9 *:cursor-pointer">
          <Link
            href="https://www.facebook.com/AbdulwahedCo/"
            prefetch={false}
            className="flex items-center"
            target="_blank"
          >
            <FaceBookIcon />
          </Link>
          <Link
            href="https://www.linkedin.com/company/ahmed-abdulwahed"
            prefetch={false}
            className="flex items-center"
            target="_blank"
          >
            <LinkedinIcon />
          </Link>
          <Link
            href="https://twitter.com/abdulwahedco?lang=en"
            prefetch={false}
            className="flex items-center"
            target="_blank"
          >
            <TwitterIcon />
          </Link>
          <Link
            href="https://www.instagram.com/ahmedabdulwahed.co/"
            prefetch={false}
            className="flex items-center"
            target="_blank"
          >
            <InstagramIcon />
          </Link>
          <Link
            href="https://www.youtube.com/channel/UCGT1npjcGoVUdhA6gyynrxg"
            prefetch={false}
            className="flex items-center"
            target="_blank"
          >
            <YoutubeIcon />
          </Link>
        </div>
      </div>
      <CompareProductFooter />
    </div>
  );
};

export default FooterApps;
